export default __webpack_public_path__ + "static/media/EzDelivery_logocp-resource@3x.60211c41.png";